module.exports = __webpack_public_path__ + "static/media/高分多模卫星.398eb623.png";